import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DoctorProfileRoutingModule } from './doctor-profile-routing.module';
import { DoctorProfileComponent } from './doctor-profile.component';
import { ShowServicesDialogComponent } from './components/show-services-dialog/show-services-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import {MatSelectModule} from '@angular/material/select';
import {MatTooltipModule} from '@angular/material/tooltip';
import { AgmCoreModule } from '@agm/core';
import {MatIconModule} from '@angular/material/icon';
import { SlickCarouselModule } from 'ngx-slick-carousel';
// import { NgxStarRatingModule } from 'ngx-star-rating';
import { SharedModule } from 'src/app/shared/shared.module';
import { SharedSocialComps } from 'src/app/doctor/doctor-social/shared-social-com/shared-social.module';


@NgModule({
  declarations: [
    DoctorProfileComponent
  ],
  imports: [
    CommonModule,
    DoctorProfileRoutingModule,
    SharedSocialComps,
    SharedModule,
    MatDialogModule,
    MatButtonModule, 
    NgSelectModule,
    FormsModule,
    MatSelectModule,
    MatTooltipModule,
    SlickCarouselModule,
    MatIconModule,
    // NgxStarRatingModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyARBya2cNTTGDWtFjgRolSb3Pp3scWzA1k',
      // AIzaSyARBya2cNTTGDWtFjgRolSb3Pp3scWzA1k
      libraries: ['places']
    })
  ]
})
export class DoctorProfileModule { }
